// extracted by mini-css-extract-plugin
export default {"container":"Metadata-module__container--tL6Q3","heading":"Metadata-module__heading--HAxII"};